import "./SelfVerification.css";

import React, { useContext, useState } from "react";

import Guidelines from "../common/Guidelines";
import HitachiTopLogo from "../../resources/topLogo";
import Loader from "../common/Loader/Loader";
import { SVTUserContext } from "../../utils/SVTUserContext";
import SelfVerificationAssessment from "./SelfVerificationAssessment";
import SelfVerificationContent from "./SelfVerificationContent";
import SelfVerificationResults from "./SelfVerificationResults";
import SelfVerificationTemplates from "./SelfVerificationTemplates";
import useGetAllTemplateMasterData from "../../utils/useGetAllTemplateMasterData";

const SelfVerificationMain = () => {
    const {
        activeTab,
        setActiveTab,
        isGuidelinesModalOpen,
        setIsGuidelinesModalOpen,
    } = useContext(SVTUserContext);

    const [templateData, levelsData, loading] = useGetAllTemplateMasterData();
    const renderContent = () => {
        switch (activeTab) {
            case "Tab1":
                return <SelfVerificationContent />;
            case "Tab2": {
                return loading ? (
                    <Loader />
                ) : (
                    <SelfVerificationTemplates templateData={templateData} />
                );
            }
            case "Tab3":
                return <SelfVerificationAssessment levelsData={levelsData} />;
            case "Tab4":
                return <SelfVerificationResults levelsData={levelsData} />;
            default:
                return null;
        }
    };

    const handleCloseModal = () => {
        setIsGuidelinesModalOpen(false);
        activeTab === "Tab1" && setActiveTab("Tab2");
    };
    return (
        <div className="container">
            <div className="main-content">
                <HitachiTopLogo />
                <div className="content ">
                    {renderContent()}
                    {isGuidelinesModalOpen && (
                        <Guidelines onNext={handleCloseModal} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default SelfVerificationMain;
